module.exports = __webpack_public_path__ + "static/img/1095.e5007ea.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1095.jpg
// module id = 277
// module chunks = 0